<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const snippet = `
    <div class="text-center">
      <h3 class="heading heading-3 mt-8 mb-6">Without a Container</h3>
      <div class="p-6 bg-brand-base">
        <p class="copy bold m-auto text-white">
          Components without a Container expand to their parent's width.
        </p>
      </div>
    </div>
    <div class="container text-center">
      <h3 class="heading heading-3 mt-8 mb-6">With a Container</h3>
      <div class="p-6 bg-brand-base">
        <p class="copy bold m-auto text-white">
          Components inside our Container are restricted to the 960px max width, and centred horizontally above this screen size.
        </p>
      </div>
    </div>
  `;
</script>

<template>
  <section id="container" class="page-section bg-lightest">
    <div class="container">
      <h2 class="heading heading-2 my-6">Container</h2>
    </div>
    <div class="space-y-6">
      {@html snippet}
    </div>
    <div class="container">
      <CodeSnippet id="container" {snippet} />
    </div>
  </section>
</template>
